import { Type } from '@sinclair/typebox';
import { LimitOrderSchema } from '../limit-order.js';
import { PoolSchemaExtended } from '../pool/pool-extended.js';
import { TradeSwapDetailsSchema, TradeSwapRollingStatsSchema, TradeSwapStatusSchema, } from './swap.js';
export const TradeLimitOrderSchema = Type.Composite([
    LimitOrderSchema,
    Type.Object({
        pairMeta: PoolSchemaExtended,
        swaps: Type.Array(Type.Object({
            txHash: Type.String(),
            status: TradeSwapStatusSchema,
            tokenIn: Type.String(),
            tokenOut: Type.String(),
            swapDetails: Type.Optional(TradeSwapDetailsSchema),
            createdAt: Type.String(),
            rollingStats: TradeSwapRollingStatsSchema,
            pnl: Type.String(),
        })),
    }),
]);
export const EvmLimitOrderResponseIxsSchema = Type.Object({
    minNonce: Type.Number(),
    maxNonce: Type.Number(),
    signatures: Type.Array(Type.String(), {
        description: 'Array of signed transactions for EVM networks',
    }),
});
export const SvmLimitOrderResponseIxsSchema = Type.Object({
    nonce: Type.String(),
    nonceAccount: Type.String({
        description: 'Nonce account address for SVM networks',
    }),
    serializedTransaction: Type.String({
        description: 'Serialized transaction in hex format for SVM networks',
    }),
});
export const TradeLimitOrderPrepareInstructionsSchema = Type.Union([EvmLimitOrderResponseIxsSchema, SvmLimitOrderResponseIxsSchema], {
    description: 'Instructions for preparing limit order transactions',
});
export const TradeLimitOrderPrepareNonceInstructionsResponseSchema = Type.Union([
    Type.Object({
        nonceAccount: Type.String({
            description: 'Nonce account address',
        }),
        serializedTransaction: Type.String({
            description: 'Serialized transaction in hex format',
        }),
    }),
    Type.Object({
        nonceAccount: Type.String({
            description: 'Nonce account address',
        }),
        nonce: Type.String({
            description: 'Nonce',
        }),
    }),
], { title: 'TradeLimitOrderPrepareNonceInstructionsResponseSchema' });
//# sourceMappingURL=limit-order.js.map